import CsReport from './report.vue'
CsReport.install = function (Vue) {
    Vue.component(CsReport.name, CsReport)
}
export default CsReport


// WEBPACK FOOTER //
// ./src/components/report/index.js